import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A low fern — fronds arching outward and up from a central base, each a pair of
// tapered capsules (root → knee → drooping tip) — rounded art style, plan 28
// stage 4 (was 3 stepped boxes per frond).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/fern.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, seed }) => {
    const base = shade(0x2e6b34, (rand(seed) - 0.5) * 0.25);
    const fronds = 5 + Math.floor(rand(seed + 1) * 3);
    for (let i = 0; i < fronds; i++) {
      const a = (i / fronds) * Math.PI * 2 + rand(seed + i) * 0.4;
      const len = 0.5 + rand(seed + i * 3) * 0.4;
      const dx = Math.cos(a), dz = Math.sin(a);
      const kneeH = 0.48, tipH = 0.26; // arch: up to the knee, drooping to the tip
      // root → knee: thicker at the base, climbing up-and-out to mid-reach
      bone(0, 0.03, 0, dx * len * 0.5, kneeH, dz * len * 0.5, 0.05, 0.035, shade(base, 0));
      // knee → tip: thinner, reaching full length while drooping back down
      bone(dx * len * 0.5, kneeH, dz * len * 0.5, dx * len, tipH, dz * len, 0.035, 0.02, shade(base, 0.06));
    }
  };

export default build;
